module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (21).11ab1e69.jpg";